import { route } from 'quasar/wrappers'
import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import { LocalStorage } from 'quasar'
import routes from './routes'

const PUBLIC_PATHS = ['/', '/signin', '/signup', '/setup']

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
  })

  const AUTH_PATHS = ['/signin', '/signup', '/']

  Router.beforeEach((to, from, next) => {
    const isPublic = PUBLIC_PATHS.includes(to.path)
    const token = LocalStorage.getItem('token')
    if (token && AUTH_PATHS.includes(to.path)) {
      next('/user/dashboard')
    } else if (!isPublic && !token) {
      next('/signin')
    } else {
      next()
    }
  })

  return Router
})
